// Dropper / dispenser window (UI-3; M15.2.1). A 3×3 grid of nine slots over an
// array container, plus the player inventory — same generic container machinery as
// the chest (transaction.clickSlot, PLR-1). Client-only (ENG-1).
import { arraySlots, type ArrayContainer } from '../../../sim/game/containers/array';
import { maxStackFn, playerRefs, playerRows } from './crafting';
import { openWindow, refRange, returnToInventory, type SlotRef, type WindowConfig } from './container';
import type { Game } from '../../boot';

/** Open a dropper/dispenser/crafter's 9-slot (3×3) window. `title` distinguishes them. */
export function openDispenser(game: Game, data: ArrayContainer, title: 'Dropper' | 'Dispenser' | 'Crafter'): () => void {
  const slots = arraySlots(data, maxStackFn(game.registries));
  const refs = refRange(slots, 0, 9, undefined, 'dispenser');
  const pr = playerRefs(game.playerState.inventory);
  const set = new Set<object>([slots]);

  const rows: (SlotRef | null)[][] = [];
  for (let r = 0; r < 3; r++) rows.push(refs.slice(r * 3, r * 3 + 3));
  rows.push([null]);

  const cfg: WindowConfig = {
    title,
    layout: [...rows, ...playerRows(pr)],
    quickTargets: (ref) => (set.has(ref.slots) ? [...pr.storage, ...pr.hotbar] : refs),
    onClose: (cursor) => returnToInventory(game, [cursor]),
  };
  return openWindow(game, cfg);
}
